import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { OrderNode } from '@generated/graphql';

@Component({
  selector: 'result-orders-block',
  templateUrl: './result-orders-block.component.html',
  styleUrls: ['./result-orders-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResultOrdersBlockComponent {
  @Input() orders?: OrderNode[];
  @Output() rowClick = new EventEmitter();
}
